
import { defineComponent, PropType, ref, onMounted } from 'vue'

import { VideoAttributes } from '@/types/models/video'
import { toArray } from '@/utils/array'
import axiosBase from 'axios'

const convertToD640 = (url: string): string => {
  // `_295x166` や `_640x360` などのサイズ指定を削除
  const cleaned = url.replace(/_\d+x\d+/, '')
  // すでに `?region=us` 等がついている場合も維持しつつ -d_640 を挿入
  return cleaned.replace(/(-d)(\?|$)/, '-d_640$2')
}

const fetchVimeoThumbnailUrl = async (
  vimeoId: string,
  vimeoHash?: string
): Promise<string | undefined> => {
  const videoUrl = vimeoHash
    ? `https://vimeo.com/${encodeURIComponent(vimeoId)}/${encodeURIComponent(vimeoHash)}`
    : `https://vimeo.com/${encodeURIComponent(vimeoId)}`

  const oembedUrl = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`
  const response = await axiosBase.get(oembedUrl)

  const baseUrl: string | undefined = response.data?.thumbnail_url
  if (!baseUrl) return undefined

  // 295x166 を削って -d_640 を付与
  return convertToD640(baseUrl)
}

export default defineComponent({
  props: {
    video: {
      type: Object as PropType<VideoAttributes | undefined>,
      default: () => undefined,
    },
    rounded: {
      type: Boolean,
      default: () => true,
    },
    titleAlign: {
      type: String,
      default: () => 'text-left',
    },
  },
  setup(props) {
    const thumbnailUrl = ref<string | undefined>(undefined)

    const getThumbnailUrl = async (video: VideoAttributes | undefined): Promise<string | undefined> => {
      if (!video?.video_vimeo) return undefined
      // ★ DB の値は使わず、毎回取得
      return await fetchVimeoThumbnailUrl(
        video.video_vimeo.vimeo_id,
        video.video_vimeo.vimeo_hash
      )
    }

    onMounted(async () => {
      thumbnailUrl.value = await getThumbnailUrl(props.video)
    })

    return {
      toArray,
      thumbnailUrl,
    }
  },
})
